import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./toast.module.scss";
import { NotificationTwoTone } from "@ant-design/icons";

export const toastService = {
  success: (message) => {
    toast.success(message, {
      toastId: "success",
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      bodyClassName: styles["toast-message"],
    });
  },
  error: (message) => {
    toast.error(message, {
      toastId: "error",
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      bodyClassName: styles["toast-message"],
    });
  },
  notification: (title, message) => {
    toast.success(
      <div>
        <h3>
          <strong>{title}</strong>
        </h3>
        <p>{message}</p>
      </div>,
      {
        toastId: "success",
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        bodyClassName: styles["toast-message"],
        icon: <NotificationTwoTone style={{ fontSize: "22px" }} />,
      }
    );
  },
};
